import systemSettingsService from '@/api/system-settings-service';
import clone from 'just-clone';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

const state = {
  systemSettings: {},
  systemSettingsValidationErrors: {},
};

const mutations = {
  SET_SYSTEM_SETTINGS(state, settings) {
    state.systemSettingsValidationErrors = {};
    state.systemSettings = clone(settings);
  },

  STORE_SYSTEM_SETTINGS(state, settings) {
    state.systemSettings = clone(settings);
    state.systemSettingsValidationErrors = {};
  },

  SET_SYSTEM_SETTINGS_VALIDATION_ERRORS(state, validationErrors) {
    state.systemSettingsValidationErrors = validationErrors;
  },

  CLEAR_SYSTEM_SETTINGS_VALIDATION_ERRORS(state, field) {
    delete state.systemSettingsValidationErrors[field];
  },
};

const actions = {
  fetchSettings({ commit }) {
    return systemSettingsService.getSettings().then((res) => {
      commit('SET_SYSTEM_SETTINGS', res.data);
      return res.data;
    });
  },

  storeSettings({ commit }, settings) {
    return systemSettingsService
      .create(settings)
      .then((res) => {
        commit('STORE_SYSTEM_SETTINGS', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('system_settings_updated'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_SYSTEM_SETTINGS_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
